import { createFormHookContexts } from '@tanstack/react-form';

export const { formContext, fieldContext, useFieldContext, useFormContext } =
  createFormHookContexts();
